var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimesCircleSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "times-circle-solid",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "times-circle-solid-2",
    "data-name": "times-circle-solid",
    d: "M14.5,8A6.5,6.5,0,1,0,21,14.5,6.5,6.5,0,0,0,14.5,8Zm3.187,8.206a.315.315,0,0,1,0,.446l-1.038,1.035a.315.315,0,0,1-.446,0l-1.7-1.719-1.706,1.719a.315.315,0,0,1-.446,0l-1.035-1.038a.315.315,0,0,1,0-.446l1.719-1.7-1.719-1.706a.315.315,0,0,1,0-.446l1.038-1.038a.315.315,0,0,1,.446,0l1.7,1.722,1.706-1.719a.315.315,0,0,1,.446,0l1.038,1.038a.315.315,0,0,1,0,.446l-1.722,1.7Z",
    transform: "translate(-8 -8)",
    fill: "#9a9a9a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimesCircleSolid);
export default __webpack_public_path__ + "static/media/times-circle-solid.77418c1ec7592b5339849a804d13fc59.svg";
export { ForwardRef as ReactComponent };